export const colors = [
  '#026E81',
  '#00ABBD',
  '#0099DD',
  '#FF9933',
  '#A1C7E0',
  '#EE8BF0',
  '#C899F7',
  '#9896E0',
  '#99C4F7',
  '#86E7F0',
  '#8C565A',
  '#A66571',
  '#F2BFBB',
  '#BF8A8A',
  '#F2EBEB',
  '#D6E1FF',
  '#FFE9D6',
  '#FFE9D6',
  '#D6FFFD',
  '#FFFBD6',
  '#DBFFD6',
  '#FED6FF',
];
